export const deviceTypes = {
    Unknown: 0,
    SubscriptionDevice: 1,
    TraditionalDevice: 2
}
